<div class="modal-body wrapper-modal position-relative">
    <i matTooltip="Cerrar" class="fas fa-times fa-2xl close-icon-actions" (click)="dialogRef.close()"></i>
    <div class="content">
        <header class="text-center mt-3 mb-4">
            <div class="dialog-title">
                {{title}}
            </div>
        </header>
        <div class="content-child">
            <main class="d-flex flex-wrap mt-2">
                <aside class="col-lg-8 critic-zone-map-container mb-3 mb-lg-0">
                    <app-standard-map [options]="mapOptions" (clickMap)="onClickMap($event)"
                        (mapReady)="onMapReady()"></app-standard-map>
                </aside>
                <aside class="col-lg-4">
                    <form [formGroup]="form">
                        <mat-button-toggle-group [(ngModel)]="mapClickTarget" [ngModelOptions]="{standalone: true}"
                            class="mb-3" *ngIf="!isViewMode">
                            <mat-button-toggle value="start">Origen en mapa</mat-button-toggle>
                            <mat-button-toggle value="end">Destino en mapa</mat-button-toggle>
                        </mat-button-toggle-group>
                        <app-autocomplete-address [options]="{
                            title: 'Origen',
                            appearance: 'outline',
                            initialValue: startAddressInitialValue,
                            showHintRequiredAddressSelection: true
                        }" [inputFormControl]="startAddressControl" [validate]="validate">
                        </app-autocomplete-address>
                        <mat-form-field appearance="outline">
                            <mat-label>Alias de origen<span class="optional">(Opcional)</span></mat-label>
                            <input type="text" matInput formControlName="startAlias">
                        </mat-form-field>
                        <app-autocomplete-address [options]="{
                            title: 'Destino',
                            appearance: 'outline',
                            initialValue: endAddressInitialValue,
                            showHintRequiredAddressSelection: true
                        }" [inputFormControl]="endAddressControl" [validate]="validate">
                        </app-autocomplete-address>
                        <mat-form-field appearance="outline">
                            <mat-label>Alias de destino<span class="optional">(Opcional)</span></mat-label>
                            <input type="text" matInput formControlName="endAlias">
                        </mat-form-field>
                        <mat-form-field appearance="outline">
                            <mat-label>Nombre<span class="asterisk">*</span></mat-label>
                            <input type="text" matInput formControlName="name">
                            <mat-error *ngIf="form.get('name').errors?.required">
                                {{ utils.giveMessageError('MANDATORY_FIELD') }}
                            </mat-error>
                            <mat-error *ngIf="form.get('name').errors?.minlength">
                                {{ utils.giveMessageError('MIN_LENGTH_NOT_REACHED', 'nombre', 5) }}
                            </mat-error>
                        </mat-form-field>
                        <mat-form-field appearance="outline">
                            <mat-label>Motivo<span class="asterisk">*</span></mat-label>
                            <textarea matInput formControlName="reason" rows="3"></textarea>
                            <mat-error *ngIf="form.get('reason').errors?.required">
                                {{ utils.giveMessageError('MANDATORY_FIELD') }}
                            </mat-error>
                            <mat-error *ngIf="form.get('reason').errors?.minlength">
                                {{ utils.giveMessageError('MIN_LENGTH_NOT_REACHED', 'motivo', 8) }}
                            </mat-error>
                        </mat-form-field>
                    </form>
                </aside>
            </main>
        </div>
        <div class="button-container justify-content-end">
            <button mat-raised-button class="primary-secondary button-width-auto" color="secondary-dark"
                (click)="dialogRef.close()">
                {{isViewMode ? 'Cerrar' : 'Cancelar'}}
            </button>&nbsp;
            <button *ngIf="!isViewMode" mat-raised-button class="button-width-auto bg-color-primary" color="primary"
                (click)="create()">
                {{actionLabel}}
            </button>
        </div>
    </div>
</div>